// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3Y-Cq","label":"Category_label__3jbxH","content":"Category_content__2FgfK","header":"Category_header__3HVy5","location":"Category_location__FDG95"};